import { render } from "./meta4b.vue?vue&type=template&id=0386fc32&scoped=true"
import script from "./meta4b.vue?vue&type=script&lang=js"
export * from "./meta4b.vue?vue&type=script&lang=js"

import "./meta4b.vue?vue&type=style&index=0&id=0386fc32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0386fc32"]])

export default __exports__